// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Row, Col, Chart } from "@components";

type OwnProps = $Exact<{
  reportData: *,
  title: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const CurrentAbsenceStatusDepartments = ({ reportData, title, t }: Props) => {
  return (
    <Chart
      type="ColumnChart"
      title={title}
      className="mb-4"
      values={[
        ["Type", t("SHORT_TERM_ABSENCE"), t("LONG_TERM_ABSENCE")],
        ...(reportData || []).map(item => [...item]),
      ]}
      options={{
        isStacked: true,
        legend: { position: "top" },
        chartArea: { width: "95%" },
      }}
      chartHeight={300}
    />
  );
};

export default localize()(CurrentAbsenceStatusDepartments);
